export enum InvitationTypeFilter {
  OneTimeOnly = 'ONE_TIME_ONLY',
  RegularOnly = 'REGULAR_ONLY',
  All = 'ALL',
}
